<template>
  <q-page class="main">
    <common-form :action="$route('phase.update', {fase: phase.id})" is-update>
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <item-header :item="phase"/>
          <phase-form :phase="phase"/>
        </q-card-section>
        <q-separator />
        <q-card-actions align="right" class="q-pa-md">
            <accent-button label="Opslaan" type="submit"/>
        </q-card-actions>
        <common-form :action="$route('phase.merge')">
          <q-card-section class="page-card__details">
            <div class="heading-3 q-mb-md">
              Samenvoegen
            </div>
            <common-banner>
              Dit kan <strong>niet</strong> worden teruggedraaid. Alle projecten en richtlijnen in {{ phase.title }}
              worden aan een andere fase toegevoegd.
            </common-banner>

              <input type="hidden" name="source_phase_id" :value="phase.id"/>

              <q-select
                  v-model="targetPhaseId"
                  name="target_phase_id"
                  :options="otherPhases"
                  label="Kies fase"
                  class="q-my-lg"
                  outlined
              >

              </q-select>
              <warning-button v-if="$isDesktop" label="Samenvoegen" type="submit"/>
          </q-card-section>
          <q-separator v-if="!$isDesktop" />
          <q-card-actions v-if="!$isDesktop" align="right" class="bg-neutral-5 q-pa-md">
            <warning-button label="Samenvoegen" type="submit"/>
          </q-card-actions>
        </common-form>
      </q-card>
    </common-form>
    <sticky-top-bar />
  </q-page>
</template>

<script>
import PhaseForm from './PhaseForm'
import StickyBottomBar from "../../components/layout/StickyBottomBar";
import StickyTopBar from "../../components/layout/StickyTopBar";

export default {
  components: {
    StickyTopBar,
    StickyBottomBar,
    PhaseForm
  },
  props: {
    phase: {
      type: Object,
      default: () => ({})
    },
    phases: {
      type: Object,
      default: () => ({})
    },
    otherPhases: {
      type: Array,
      default: () => ({})
    }
  },
  data() {
    return {
      targetPhaseId: null
    }
  }
}
</script>
